// src/authConfig.js
import config from "./config";

export const msalConfig = {
  auth: {
    clientId: config.AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${config.AZURE_TENANT_ID}`,
    redirectUri: `${config.REDIRECT_URL}`,
    postLogoutRedirectUri: `${config.POSTREDIRECT_URL}`,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};



// // src/authConfig.js
// import config from "./config";
// export const msalConfig = {
//   auth: {
//     clientId: config.AZURE_CLIENT_ID, // Replace with your Azure AD app's client ID
//     authority:
//       `https://login.microsoftonline.com/${config.AZURE_TENANT_ID}`, // Replace with your Azure AD tenant ID
//     redirectUri: window.location.origin,
//     // redirectUri: "https://erasurvey.excavateresearch.in/",
//     postLogoutRedirectUri: window.location.origin + '/login'
//     //postLogoutRedirectUri: "/", // Ensure this is the correct URI after logout
//   },
//   cache: {
//     cacheLocation: "localStorage", // Configure cache location
//     storeAuthStateInCookie: false, // Recommended for IE11 or older browsers
//   },
// };
